import { FEATURE_NAME, USER_ROLE } from "@/constants";
import helpers from "@/helpers";

export default {
  loggedIn(state) {
    return !!state.authData;
  },
  getAuthUserData(state) {
    if (state.authData && state.authData.user) {
      return state.authData.user;
    }
  },
  getAuthData(state) {
    return state.authData;
  },
  isTravelAgent(state) {
    return helpers.hasAnyRoles(
      state.authData.user,
      [USER_ROLE.TRAVEL_AGENT],
      false
    );
  },
  isAdmin(state) {
    return helpers.hasAnyRoles(
      state.authData.user,
      [USER_ROLE.ADMIN, USER_ROLE.SUPPORT],
      true
    );
  },
  isProVersion(state) {
    return state.authData.user_type.name === "pro";
  },
  authConfig(state) {
    const proEnabled = state.authData.user_type.name === "pro";

    const proFeatures = [
      FEATURE_NAME.TAB_SERVICES,
      FEATURE_NAME.HISTORY_VIEW,
      FEATURE_NAME.LANGUAGE_SELECTOR,
      FEATURE_NAME.OWNER_ASSIGNEE,
      FEATURE_NAME.ITINERARY_TYPE_CHANGE,
      FEATURE_NAME.ITINERARY_EXPORT,
      FEATURE_NAME.EXPERIENCE,
      FEATURE_NAME.REQUEST,
      FEATURE_NAME.PRICE_LEVEL_LABEL,
      FEATURE_NAME.ITINERARY_STATUS,
      FEATURE_NAME.REPORT,
      FEATURE_NAME.WORD_EXPORT,
      FEATURE_NAME.AUTOCOMPLETE,
      FEATURE_NAME.MATRIX_CALCULATION,
    ];

    return {
      proFeatures: proFeatures,
      languageEnabled: proEnabled,
      currencyEnabled: proEnabled,
      serviceDayEnabled: proEnabled,
      tripTypeEnabled: proEnabled,
      clientDisplayEnabled: proEnabled,
      roomDistributionEnabled: proEnabled,
      contractClientDisplayEnabled: proEnabled,
      exampleItineraryEnabled: proEnabled,
      experienceEnabled: proEnabled,
      recalculationEnabled: proEnabled,
      requestEnabled: proEnabled,
      salesManualDisplayEnabled: proEnabled,
      serviceConfigEnabled: proEnabled,
      statusChangeEnabled: proEnabled,
      statusEnabled: proEnabled,
    };
  },
};
